export default __webpack_public_path__ + "static/media/LoginLogo.066b0a13.png";